export default "__VITE_ASSET__44d9ee10__"